import { types } from 'mobx-state-tree';
import { AlertType } from './types';
import { DEFAULT_ALERT_TIMOUT } from './constants';

const { model, string, boolean, frozen, number } = types;

export const AlertStore = model('AlertStore', {
  show: boolean,
  message: string,
  type: frozen<AlertType>(),
  timeout: number,
})
  .views((self) => ({}))
  .actions((self) => ({
    showAlert(message: string, type: AlertType = 'error', timeout?: number) {
      self.message = message;
      self.type = type;
      self.show = true;
      if (timeout) self.timeout = timeout;
    },
    hideAlert() {
      self.show = false;
      self.message = '';
      self.timeout = DEFAULT_ALERT_TIMOUT;
    },
  }));
